declare global {
    interface Window {
        analytics: any
    }
}

export interface SegmentConfig {
    writeKey: string
    cdn?: string
}

export const SEGMENT_CONFIGS = {
    production: {
        writeKey: 'vge0rHGUKWaaZtBNN0j9bpQBolWSCE3W',
        cdn: 'https://evs.segment.generalmedicine.co'
    },
    staging: {
        writeKey: 'MEBWgiCg3iB59CBVEhzgCKXhnSzHaSU7',
        cdn: 'https://evs.segment.staging-nile.com'
    }
} as const

export function getSegmentSnippet(config: SegmentConfig): string {
    const cdnPath = config.cdn || 'https://cdn.segment.com'

    return `
        !function(){var i="analytics",analytics=window[i]=window[i]||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","screen","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware","register"];analytics.factory=function(e){return function(){if(window[i].initialized)return window[i][e].apply(window[i],arguments);var n=Array.prototype.slice.call(arguments);if(["track","screen","alias","group","page","identify"].indexOf(e)>-1){var c=document.querySelector("link[rel='canonical']");n.push({__t:"bpc",c:c&&c.getAttribute("href")||void 0,p:location.pathname,u:location.href,s:location.search,t:document.title,r:document.referrer})}n.unshift(e);analytics.push(n);return analytics}};for(var n=0;n<analytics.methods.length;n++){var key=analytics.methods[n];analytics[key]=analytics.factory(key)}analytics.load=function(key,n){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.setAttribute("data-global-segment-analytics-key",i);t.src="${cdnPath}/aSfgdYZrtuMRGKtZJMqknU/${config.writeKey === 'vge0rHGUKWaaZtBNN0j9bpQBolWSCE3W' ? '8RbjYFp1hi4Fbfn3T3dHNW' : 'aD5rW34y41B1CJQVHW4JyZ'}.min.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r);analytics._loadOptions=n};analytics._writeKey="${config.writeKey}";analytics._cdn = "${cdnPath}";analytics.SNIPPET_VERSION="5.2.0";
        analytics.load("${config.writeKey}");
        }}();
    `
}

export function initializeSegment(env: 'production' | 'staging' = 'staging') {
    if (typeof window === 'undefined') return

    const config = SEGMENT_CONFIGS[env]
    const script = document.createElement('script')
    script.innerHTML = getSegmentSnippet(config)
    document.head.appendChild(script)
}

export function trackEvent(eventName: string, properties?: Record<string, any>) {
    if (typeof window !== 'undefined' && window.analytics && typeof window.analytics.track === 'function') {
        window.analytics.track(eventName, properties)
    }
}

const INSURANCE_EVENT_PREFIX = 'ssi_'

export function trackInsuranceEvent(eventName: string, properties?: Record<string, any>) {
    trackEvent(`${INSURANCE_EVENT_PREFIX}${eventName}`, properties)
}

const NEXT_STEPS_EVENT_PREFIX = 'ns_'

export function trackNextStepsEvent(eventName: string, properties?: Record<string, any>) {
    trackEvent(`${NEXT_STEPS_EVENT_PREFIX}${eventName}`, properties)
}

const STORE_EVENT_PREFIX = 'sf_'

export function trackStoreEvent(eventName: string, properties?: Record<string, any>) {
    trackEvent(`${STORE_EVENT_PREFIX}${eventName}`, properties)
}

export function identifyUser(userId: string, traits?: Record<string, any>) {
    if (typeof window !== 'undefined' && window.analytics && typeof window.analytics.identify === 'function') {
        window.analytics.identify(userId, traits)
    }
}

export function aliasUser(userId: string) {
    if (typeof window !== 'undefined' && window.analytics && typeof window.analytics.alias === 'function') {
        window.analytics.alias(userId)
    }
}

export function trackPage(name?: string, properties?: Record<string, any>) {
    if (typeof window !== 'undefined' && window.analytics && typeof window.analytics.page === 'function') {
        window.analytics.page(name, properties)
    }
}

export function resetUser() {
    if (typeof window !== 'undefined' && window.analytics && typeof window.analytics.reset === 'function') {
        window.analytics.reset()
    }
}

export const SegmentAnalytics = {
    initialize: initializeSegment,
    track: trackEvent,
    identify: identifyUser,
    alias: aliasUser,
    page: trackPage,
    reset: resetUser,
}

export default SegmentAnalytics